<template lang="pug">
  BaseTable(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :table="table"
    :items="items"
    :meta="meta"
    :sort="sort"
    :page="page"
    :onDelete="onDelete"
    :toggleSort="toggleSort"
    :changePage="changePage"
  )
</template>

<script>
import BaseTable from '@/components/app/BaseTable'
import store from '@/store'
import { mapState, mapMutations } from 'vuex'

export default {
  components: { BaseTable },
  data: vm => ({
    title: vm.$t('cities.countries.title')
  }),
  computed: {
    ...mapState('citiesCountries', ['routeKey', 'routes', 'table', 'items', 'meta', 'sort', 'page']),
    crumbs: vm => [
      { text: vm.$t('cities.title'), to: { name: 'cities.index' } },
      { text: vm.$t('cities.countries.title') }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('citiesCountries/fetchItems')
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapMutations('citiesCountries', ['SET_SORT', 'SET_PAGE']),
    async onDelete (id) {
      await store.dispatch('citiesCountries/deleteItem', { id })
      await store.dispatch('citiesCountries/fetchItems')
      this.$notify({ message: this.$t('forms.notify.deleted') })
    },
    async toggleSort (field) {
      this.SET_SORT(field)
      await store.dispatch('citiesCountries/fetchItems')
    },
    async changePage (page) {
      this.SET_PAGE(page)
      await store.dispatch('citiesCountries/fetchItems')
    }
  }
}
</script>
